import { log } from "util";
import ibsStore from "../../../Stores/IbsSurveyStore";
import store from "../../../Stores/SurveyStore";
import { isNotEmptyorNA, isCellNA } from "../../../../Helpers/TableHelper";
import { mandateToAssetErrorMapping, mandateToAssetMapping, LpColumnNames } from "./MandateTableFieldMappings";
import { isDerivativesCategory } from "../../../../ibsHelper";
import { NumberFormat } from "../../../../Enums/constants";
import { toNumber } from "../../../../helpers";
import { formatNumber } from "../../../../Helpers/General/FormatHelper";

export function assetMandateCellRenderer(instance, td, row, col, prop, value, cellProperties, props, referenceToTable, lastEncounteredImplStyle, lastEncounteredAssetCat, listOfAssetRows, rowJustAdded)  {
    //log(`cellRenderer`, 4);

    let rowId = (referenceToTable[row]?.RowID)?.toString()

    let rowData = []
    if (rowId?.charAt(0) == "A") {
        rowData = ibsStore.allTableResponses["combinedAssets"].filter(function (v) {
            return v.RowID.toString() == rowId.replace('A', '');
        })
        lastEncounteredImplStyle = rowData.length > 0 ? rowData[0].StyleName : ""
        lastEncounteredAssetCat = rowData.length > 0 ? rowData[0].AssetClassCategoryName : ""

    } else {
        rowData = ibsStore.mandateData.filter(function (v) {
            return v.rowID.toString() == rowId;
        });
        lastEncounteredImplStyle = rowData.length > 0 ? rowData[0].styleName : ""
        lastEncounteredAssetCat = rowData.length > 0 ? rowData[0].assetClassCategoryName : ""
    }

    // TODO There is an old comment, not sure if still applicable: might need to check if DB Assets because this is special formatting
    if (!props.tableName || !referenceToTable) {
        return;
    }
    let checkCellNA = isCellNA(row, col, props, referenceToTable, lastEncounteredImplStyle, lastEncounteredAssetCat, lastEncounteredAssetCat)
    referenceToTable[row][prop] = checkCellNA ? "N/A" : value


    if (row !== referenceToTable.length - 1 && checkCellNA) {
        value = "N/A"
        td.className = td.className + "cellNA readOnlyCell"
        td.style.textAlign = "right !important"
        cellProperties.readOnly = true

    } else if (isNotPrivateEquityCell(row, col, prop, referenceToTable)) {
        //Dont recall the significance of this check
    } else {;
        td.className = td.className + " regCell";

        if (row === rowJustAdded) {
            td.className = "highlightTableRow";
        }

        if (col === props.headers.length - 1) {
            td.className = "delCol";
        }

        if (listOfAssetRows.indexOf(row) > -1 && (col === 3 || col === 4)) {
            td.className = td.className + " noBorder";   
        }

        if (col === 0 || col === 1 || col === 2 || col === 3 || col === 4 || col === 14) {
            td.className = td.className + " readOnlyCell";
            cellProperties.readOnly = true;
        } else if (col === 15) {
            td.className = td.className + " readOnlyCell htRight";
        } else {
            td.className = td.className + " htRight "; //right align if not read only
        }
    }


    //We need to now also grey out the InternalCosts
    if (prop == 'CostInternManage') {
        if (ibsStore.currentSurvey) {
            var hasCostValues = false;
            if (ibsStore.allTableResponses["combinedAssets"]) {
                hasCostValues = ibsStore.allTableResponses["combinedAssets"]
                    .filter(item => {
                        const costs = item["InternalMonitoringCost"];
                        return (costs && typeof costs !== 'undefined');
                    }).length > 0;
            }
            if (ibsStore.isEnhanced) {
                if (hasCostValues && ibsStore.accountInfo.UserRoleID !== 3) {
                    //Show but grey it out
                    td.className = td.className + "readOnlyCell"
                    cellProperties.readOnly = true
                }

            }
        }
    }


    let currentRowID = undefined;
    if (referenceToTable[row])
        currentRowID = referenceToTable[row].RowID

    // Set Row Id in cell
    td.id = currentRowID


    // Set Value in cell
    if (store.questionMode) {
        td.innerHTML = prop
    } else {
        if (isDerivativesCategory(lastEncounteredAssetCat) && prop == "ReturnPct" && (value !== null && value !== "") && value !== "N/A") {
            value = formatNumber(NumberFormat.MONEYTHOUSAND, toNumber(value));
        }
        else if (props.formatting && props.formatting[col] && (value !== null && value !== "") && value !== "N/A") {
            value = formatNumber(props.formatting[col], toNumber(value))
            
        }
        if (prop !== "AssetClassCategoryName" && value !== "" || row == referenceToTable.length - 1) td.innerHTML = value
        else td.innerHTML = ""
    }

    //TO:DO nicer formating needed
    if (prop == "ManagerName" || prop == "FundName") {
        td.title = value
    }
    if (prop === "ManagerName") {
        td.className += " pointer";
    }


    let assetProp = mandateToAssetErrorMapping[prop];
    let parentACpop = mandateToAssetMapping[prop]
    let parentID = referenceToTable[row].ParentAssetRowId

    
    let disableRowLockingFlag = false;

    // Check for invalid locking state depending on row type
    // Note: adds a little overhead as this runs on every row, if this becomes a problem, move to useEffect hook
    if (currentRowID[0] != "A") {
        disableRowLockingFlag = !(checkAnyMandateFilled(parentID, referenceToTable) ^ checkAnyAssetCellFilled(parentID))
    }
    if (currentRowID[0] == "A") {
        disableRowLockingFlag = !(checkAnyMandateFilled(currentRowID, referenceToTable) ^ checkAnyAssetCellFilled(currentRowID))
    }

    // Anything after this 'if' should be row locking related
    if (disableRowLockingFlag) {
        return cellProperties;
    }

    //TODO: now just omit asset return and internal costs for both
    //LOCK OUT MANDATE OR ASSET ROW FUNCTIONALITY, note: dropdowns handled in cell renderer 
    //handle Asset Class cells to disable because any of their mandate children cells are filled in 
    if (currentRowID[0] == "A" && (prop != "ReturnPct" && prop != "InternalMonitoringCost" && prop != "CostInternManage" && prop != "AssetClassName" && prop != "totalRowCost")) {
        let anyMandateFilled = checkAnyMandateFilled(currentRowID, referenceToTable)
        if (anyMandateFilled) {
            cellProperties.readOnly = true
            td.className = td.className + " readOnlyCell"
        } else if (td.innerHTML != "N/A" && store.userCanEditReadOnlySurvey) {
            cellProperties.readOnly = false
            td.className = " regCell htRight"

        }

    }

    //handle Mandate cells to disable because any of the Parent Asset class cells are filled in 
    if (currentRowID[0] != "A") {
        let anyAssetFilled = checkAnyAssetCellFilled(parentID)
        if (anyAssetFilled) {
            cellProperties.readOnly = true
            td.className = td.className + " readOnlyCell"
        } else if (td.innerHTML != "N/A" && store.userCanEditReadOnlySurvey) {
            cellProperties.readOnly = false
        }

    }

    //Handle special columns where asset classes can be overridden even if there are mandates but mandate cells will disable if there is an override
    if (currentRowID[0] != "A" && (prop == "InternalMonitoringCost" || prop == "CostInternManage")) {
        let parentAssetIsFilled = checkParentAssetCellFilled(parentID, prop)
        if (parentAssetIsFilled) {
            cellProperties.readOnly = true
            td.className = td.className + " readOnlyCell"
        }
    }
    return cellProperties
}

export function checkAnyAssetCellFilled (parentID) {
    //check all relevant fields
    let indexOfParent = ibsStore.allTableResponses["combinedAssets"].findIndex(function (v, i) {
        return v.RowID == parentID?.substring(1)
    });
    let parentAssetRow = ibsStore.allTableResponses["combinedAssets"][indexOfParent]
    if (parentAssetRow && (isNotEmptyorNA(parentAssetRow.HoldingsMillions) || isNotEmptyorNA(parentAssetRow.CostPerformanceThousands) || isNotEmptyorNA(parentAssetRow.CostBaseFeesThousands) || isNotEmptyorNA(parentAssetRow.UnderlyingFundFees) || isNotEmptyorNA(parentAssetRow.UnderlyingPerfFees) || isNotEmptyorNA(parentAssetRow.HoldingFeeAvg) || isNotEmptyorNA(parentAssetRow.CustomAssetID) || isNotEmptyorNA(parentAssetRow.InternalTeamID))) {
        return true
    }
    return false

}
export function checkParentAssetCellFilled(parentID, columnName) {
    //check all relevant fields
    let indexOfParent = ibsStore.allTableResponses["combinedAssets"].findIndex(function (v, i) {
        return v.RowID == parentID?.substring(1)
    });
    let parentAssetRow = ibsStore.allTableResponses["combinedAssets"][indexOfParent]
    let parentName = mandateToAssetMapping[columnName]
    if (parentAssetRow && isNotEmptyorNA(parentAssetRow[parentName])) {
        return true
    }
    return false

}
export function checkAnyMandateFilled(parentID, referenceToTable) {
    let childFieldFilled = referenceToTable ? referenceToTable.find(function (v, i) {
        return (v.ParentAssetRowId == parentID && (isNotEmptyorNA(v.HoldingNavAvg) || isNotEmptyorNA(v.HoldingFeeAvg) || isNotEmptyorNA(v.CostManagerBase) || isNotEmptyorNA(v.CostManagerPerf) || isNotEmptyorNA(v.CostUnderlyBase) || isNotEmptyorNA(v.CostUnderlyPerf) || isNotEmptyorNA(v.CustomAssetID) || isNotEmptyorNA(v.InternalTeamID)))
        

    }): null

    if (childFieldFilled) {
        return true
    }
    return false
}

const isNotPrivateEquityCell = (row, col, prop, referenceToTable) => {
    let styleName;

    if (referenceToTable[row]) {
        styleName = referenceToTable[row].StyleName
    }

    if (LpColumnNames.includes(prop) && (styleName != "Fund of Funds" && styleName != "Fund (LP)" && styleName != "Fund (LP, Value Add)")) {
        return true;
    }

    return false;
}

export function dropdownNARenderer (instance, td, row, col, prop, value, cellProperties) {
    td.innerHTML = "N/A"
    td.className = td.className + "cellNA"
    td.style.textAlign = "right !important"
    cellProperties.readOnly = true;
    cellProperties.type = 'numeric'


}